
/* Extend Date object */

Date.prototype.toCsDateString = function () {
    return this.toLocaleDateString('cs');
}

Date.prototype.toCsTimeString = function () {
    let minuesWithLeadingZero = ('0' + this.getMinutes()).slice(-2);
    return `${this.getHours()}:${minuesWithLeadingZero}`;
}

Date.prototype.toCsDayOfWeekString = function () {
    return [
        'Neděle',
        'Pondělí',
        'Úterý',
        'Středa',
        'Čtvrtek',
        'Pátek',
        'Sobota'
    ][this.getDay()];
}

Date.prototype.toYmdString = function () {
    const tzOffsetInMs = this.getTimezoneOffset() * 60 * 1000;
    return (new Date(this.getTime() - tzOffsetInMs))
        .toISOString().split('T')[0];
}

Date.prototype.toYmdHisString = function () {
    const localTime = this.toTimeString().split(' ')[0];
    return `${this.toYmdString()} ${localTime}`;
}

Date.prototype.addDays = function (count) {
    this.setDate(this.getDate() + count);
    return this;
}

Date.prototype.addWeeks = function (count) {
    this.addDays(7 * count);
    return this;
}
